import { Component, OnInit, Inject, ViewChild } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FeeScheduleService } from '../services/fee-schedule.service';
import {MatButton} from '@angular/material/button';
import {FeeScheduleDoctorDataModel} from '../../../models/fee-schedule/fee-schedule-doctor.model';
import {DoctorTypeEnum} from '../../../models/enum/doctor-type.enum';
import {FeeScheduleDataModel} from '../../../models/fee-schedule/fee-schedule-data.model';
import {FeeScheduleListViewDataModel} from '../models/fee-schedule-list-view.model';

@Component({
  selector: 'app-create-fee-schedule-doctor-form',
  templateUrl: './create-fee-schedule-doctor-form.component.html',
  styleUrls: ['./create-fee-schedule-doctor-form.component.css']
})

export class CreateFeeScheduleDoctorFormComponent implements OnInit {

  @ViewChild('btnCreate') btnCreate: MatButton;

  FeeScheduleID: string = '';
  DoctorId: string;
  Description: string = '';
  DocFeeScheduleID: string;
  copyMode: boolean = false;

  userHasChangedDescription: boolean = false;
  isLoading: boolean = true;
  doctorList: FeeScheduleDoctorDataModel[] = [];
  isNew: boolean = true;
  titleName: string;

  constructor(
    public dialogRef: MatDialogRef<CreateFeeScheduleDoctorFormComponent>,
    private feeScheduleService: FeeScheduleService,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
    if (data.defaultDoctorId) {
      this.DoctorId = data.defaultDoctorId;
    }
    if (data.copyMode) {
      this.copyMode = data.copyMode;
    }
    if (data.docFeeScheduleId) {
      this.DocFeeScheduleID = data.docFeeScheduleId;
    }
    if (data.titleName) {
      this.titleName = data.titleName;
    }
    if (data.FeeScheduleId) {
      this.FeeScheduleID = data.FeeScheduleId;
    }
  }

  ngOnInit() {
    this.getDoctorList();

    // show fee schedule description
    this.titleName = this.titleName;
  }

  getDoctorList() {
    this.isLoading = true;
    this.feeScheduleService.getDoctors()
      .subscribe(response => {
        this.doctorList = response;

        // format default dr item
        this.doctorList.forEach(item => {
          if (item.enumDoctorTypeID === DoctorTypeEnum.DEFAULTFEE) {
            item.FirstName = '';
            item.LastName = '';
            item.Title = 'Default fees for ' + this.titleName;
          }
        });

        // sort by dr name, always showing the default dr at the top
        this.doctorList = this.doctorList.sort((a, b) => {
          // if (a.enumDoctorTypeID === '00000004-1000-0000-0000-000000000003') { return -2; }
          if (a.FirstName + a.LastName < b.FirstName + b.LastName) { return -1; }
          if (a.FirstName + a.LastName > b.FirstName + b.LastName) { return 1; }
          return 0;
        });


        //
        // if (this.DoctorId) {
        //   this.doctorList = this.doctorList.filter(doctor => doctor.DoctorId === this.DoctorId);
        // }

        this.isLoading = false;
      }, err => {
        this.isLoading = false;
        // err
      });
  }

  // showNewOrCopy(event) {
  //   if (event === '1') {
  //     // create new
  //     this.isNew = true;
  //   }
  //   else {
  //     this.isNew = false;
  //   }
  // }

  close() {
    this.dialogRef.close({
      FeeScheduleID: this.FeeScheduleID,
      DoctorId: this.DoctorId,
      Description: this.Description,
      DocFeeScheduleID: this.DocFeeScheduleID,
      isNew: this.isNew
    });
  }

  cancel() {
    this.dialogRef.close(false);
  }

  changeDescription(event) {
    // description
    this.Description = event.source.triggerValue;
    this.btnCreate.disabled = false;

    // // id selected
    // if (!this.isNew) {
    //   this.DocFeeScheduleID = event.value;
    //   const selected: FeeScheduleDoctorDataModel = this.feeSchedule.dataFeeScheduleDoctors.find(doctor => doctor.DocFeeScheduleID === this.DocFeeScheduleID);
    //   this.DoctorId = selected.DoctorId;
    // }
  }

  onCancelClick() {
    this.cancel();
  }

  onOkClick() {
    this.close();
  }
}
